module.exports = __webpack_public_path__ + "static/media/desarrollo6.c1a3b2e8.png";